import React from "react";
import { useSelector } from "react-redux";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import { Card, Button } from "antd";
import "./styles/notifications.css";
import PDF from "../assets/pdfs/T1 Terms and Conditions.pdf";
import { useNavigate } from "react-router-dom";
import { DownloadOutlined, BackwardOutlined } from "@ant-design/icons";
const TermsService = () => {
  const history = useNavigate();
  const namingData = useSelector((state) => state.user);
  //console.log(namingData);
  return (
    <div>
      {" "}
      <div className="main-body">
        <header>
          <NavBar data={namingData.data} />
        </header>
        <div className="main-container">
          <div className="first-pp">
            <div style={{ width: "75%", margin: "0 auto" }}>
              <Card
                // size="small"
                hoverable
                bodyStyle={{
                  padding: "2rem",
                  paddingTop: "0",
                  paddingBottom: "1rem",
                }}
                style={{
                  width: "auto",
                  paddingBottom: 10,
                  marginTop: 20,
                  borderRadius: 15,
                }}
              >
                <>
                  <div
                    className="myapps"
                    style={{
                      textAlign: "center",
                      fontSize: "1.9rem",
                      fontWeight: "600",
                    }}
                  >
                    TERMS OF SERVICE{" "}
                  </div>
                  <div className="privacy-container-2">
                    <p>Last Modified Date: May 1, 2023</p>
                    <br />
                    <p>TERMS OF USE</p>
                    <p>EFFECTIVE DATE: February 28, 2020</p>
                    <br />
                    <p>1. ACCEPTANCE AND MODIFICATIONS</p>
                    <p>
                      Training Network LLC dba (“Trainery” “we,” “us,” and
                      “our”) provides the website maintained at
                      https://www.trainery.one and its subpages (the “Site”) and
                      the talent management software services and related
                      services available through the Site (the “Services”) to
                      you subject to these Terms of Use (these “Terms”). These
                      Terms establish the terms, conditions, rights and
                      responsibilities applicable to your use of the Site and
                      Services. Unless explicitly stated otherwise, any new
                      features that augment or enhance the current Site and
                      Services shall be subject to these Terms. If you have
                      entered into a separate agreement with Trainery1 Software
                      governing your use of the Site and/or Services (“Access
                      Service Agreement”), the Access Service Agreement will
                      additionally apply to your use of the Site and/or
                      Services, and will govern in the event of any conflict or
                      inconsistency with these Terms. Your breach of any of
                      these Terms or the Access Service Agreement causes an
                      automatic termination of the rights and licenses granted
                      to you hereunder.
                    </p>
                    <p>
                      PLEASE READ THESE TERMS CAREFULLY BEFORE USING THE SITE
                      AND SERVICES. BY USING THE SITE AND SERVICES, YOU ARE
                      AGREEING TO COMPLY WITH THESE TERMS. IF YOU DO NOT AGREE
                      TO BE BOUND BY THESE TERMS, DO NOT USE THE SITE OR
                      SERVICES.
                    </p>
                    <p>
                      We may change these Terms from time to time for any
                      reason. We will seek to notify you of material changes
                      prior to those changes taking effect by emailing you (if
                      you have an Account), posting a notice on the Site, or by
                      other means. If you do not agree with the new version, you
                      must stop using the Site and Services and terminate your
                      Account, if you have one.
                    </p>
                    <br />
                    <p>2. AGE REQUIREMENTS</p>
                    <p>
                      No one under the age of 18 may use the Site or Services.
                      By using or attempting to use the Site and Services, you
                      represent that you meet the age requirements and that you
                      are able to enter into legally binding contracts,
                      including these Terms.
                    </p>
                    <br />
                    <p>3. OUR PROPRIETARY RIGHTS</p>
                    <p>
                      We or our licensors own all intellectual property and
                      proprietary rights, title and interest in and to the Site
                      and the Services, including without limitation the
                      TRAINERY1 trademarks and the Site copyrights. Except for
                      the limited use rights granted to you in these Terms, you
                      agree that you do not have and will not acquire any right,
                      title, or interest in any of our intellectual property or
                      other proprietary rights. Any rights not expressly granted
                      in these Terms are expressly reserved.
                    </p>
                    <br />
                    <p>4. USE OF THE SITE AND SERVICES</p>
                    <p>
                      We grant you a limited, revocable, non-exclusive,
                      non-transferable, non-sublicensable license to access and
                      use the Site and Services for their intended purposes
                      (namely, for talent management software services and
                      related services) in accordance with these Terms and any
                      Access Service Agreement. These limited rights and
                      licenses may be revoked at any time according to Section 9
                      (Termination of Access) below.
                    </p>
                    <p>
                      When using the Site and/or Services, you agree to comply
                      with all applicable federal, state, and local laws
                      including but not limited to, copyright law. Except as
                      expressly permitted in these Terms, you may not use,
                      reproduce, distribute, create derivative works based upon,
                      publicly display, publicly perform, publish, transmit, or
                      otherwise exploit the Site content or any Content that is
                      not your Content for any purpose whatsoever without
                      obtaining prior written consent from us or, in the case of
                      third-party content, its respective owner.
                    </p>
                    <p>
                      You may not cause any harm to or otherwise interfere with
                      the Site and/or Services, by (but not limited to):
                    </p>
                    <ul>
                      <li>
                        &#8226; removing, altering, covering, or distorting any
                        copyright, trademark, or other proprietary rights notice
                        on the Site, Site content or any Content that is not
                        your Content;
                      </li>
                      <li>
                        &#8226; circumventing, disabling or otherwise
                        interfering with security-related features of the Site
                        or Services including, without limitation, any features
                        that prevent or restrict use or copying of any content
                        or enforce limitations on the use of the Site or
                        Services;
                      </li>
                      <li>
                        &#8226; using an automatic device (such as a robot or
                        spider) or manual process to monitor the activity on,
                        copy or "scrape" the Site, the Services or their content
                        for any purpose without our express written permission,
                        except for search engines, traffic counters, or similar
                        basic performance monitoring technology;
                      </li>
                      <li>
                        &#8226; transmitting, using, distributing or uploading
                        programs or material that contain malicious code, such
                        as viruses, timebombs, cancelbots, worms, trojan horses,
                        spyware, or other potentially harmful programs or other
                        material or information;
                      </li>
                      <li>
                        &#8226; forging any TCP/IP packet header or part of the
                        header information in any email or newsgroup posting for
                        any reason;
                      </li>
                      <li>
                        &#8226; creating an undue burden on the Site or
                        Services;
                      </li>
                      <li>
                        &#8226; collecting or harvesting any personal
                        information from the Site or Services, including but not
                        limited to user names, passwords, or email addresses;
                      </li>
                      <li>
                        &#8226; soliciting other users to join or become members
                        of any commercial online service or other organization
                        without our prior written approval;
                      </li>
                      <li>
                        &#8226; attempting to or interfering with the proper
                        working of the Site or Services or impairing,
                        overburdening, or disabling the same;
                      </li>
                      <li>
                        &#8226; modifying, creating derivative works from,
                        decompiling, reverse engineering, or disassembling any
                        portion of the Site or Services or any Content that is
                        not your Content;
                      </li>
                      <li>
                        &#8226; using network-monitoring software to determine
                        the architecture of or extract usage data from the Site;
                      </li>
                      <li>
                        &#8226; engaging in any conduct, or encouraging or
                        assisting any third party in any conduct, that violates
                        any local, state or federal law, either civil or
                        criminal;
                      </li>
                      <li>
                        &#8226; engaging in any activity, or encourage or assist
                        any third party in any activity, that violates these
                        Terms;
                      </li>
                      <li>
                        &#8226; impersonating another user, person, or entity;
                      </li>
                      <li>
                        &#8226; interfering with or disrupting the access of any
                        user, host or network via any means including without
                        limitation by overloading, flooding, spamming, scripting
                        content creation, or linking to coupon sites;
                      </li>
                      <li>
                        &#8226; violating U.S. export laws, including, without
                        limitation, violations of the Export Administration Act
                        and the Export Administration Regulations administered
                        by the Department of Commerce; or
                      </li>
                      <li>
                        &#8226; engaging in any conduct that restricts or
                        inhibits any other user from using or enjoying the Site
                        or Services.
                      </li>
                    </ul>
                    <p>
                      You will cooperate with us to investigate any suspected or
                      actual activity that we suspect may be in breach of these
                      Terms.
                    </p>
                    <br />
                    <h5>5. ACCOUNTS</h5>
                    <p>
                      To access and use certain Services through the Site, you
                      will need to set up an account ("Account"). To set up an
                      Account, you will be asked to provide your name, email
                      address, phone number, and company information. You must
                      provide accurate information when setting up an Account
                      and keep all Account information current.
                    </p>
                    <p>
                      You are responsible for maintaining the confidentiality of
                      your password and Account. You are fully responsible for
                      all uses of your password and Account, including any
                      unauthorized use. You agree to:
                    </p>
                    <ol>
                      <li>
                        (a) keep your password confidential and not share it
                        with anyone else,
                      </li>
                      <li>
                        (b) immediately notify us of any unauthorized use of
                        your password or Account.
                      </li>
                    </ol>
                    <p>
                      You acknowledge and agree that we are authorized to act on
                      instructions received through use of your password and
                      Account, and that we may, but are not obligated to, deny
                      access or block any transaction made through use of your
                      password or Account without prior notice if we believe
                      your password and Account are being used by someone other
                      than you, or for any other reason.
                    </p>

                    <h5>6. YOUR CONTENT</h5>
                    <p>
                      As between Trainery1 Software and you, you own all
                      intellectual property and other right, title and interest
                      in and to any data, information, text, and other content
                      that you upload to or through the Site and/or Services
                      ("Content"). Except as expressly set forth in these Terms,
                      Trainery1 Software does not acquire any right, title or
                      interest in or to your Content. By uploading or submitting
                      any Content to or through the Site or Service, you grant
                      to Trainery1 Software a worldwide, non-exclusive,
                      transferable, sublicensable right and license to use,
                      copy, modify, display, and create derivatives of your
                      Content as we deem necessary to provide the Site and
                      Services, including but not limited to, to improve or
                      enhance the Site and Services, to develop new features and
                      functionality, and for research, benchmarking, and other
                      statistical purposes.
                    </p>
                    <p>
                      You are solely responsible for all of your Content. We
                      have the right, but do not assume the obligation or
                      responsibility, to monitor your Content and to determine
                      whether it complies with applicable laws and these Terms.
                    </p>
                    <br />
                    <h5>7. THIRD-PARTY LINKS</h5>
                    <p>
                      The Site and Services may provide links to third-party
                      websites, advertisements, or resources. Because we have no
                      control over such sites, advertisements, or resources, we
                      are not responsible for the availability of such external
                      websites or resources, and we do not endorse and are not
                      responsible or liable for any content, advertising,
                      products, or other materials on or available from such
                      third-party sites or resources. We are not responsible or
                      liable, directly or indirectly, for any damage or loss
                      caused or alleged to be caused by or in connection with
                      your use of or reliance on any such content, goods, or
                      services available on or through any such third-party
                      website or resource.
                    </p>
                    <br />
                    <h5>8. MODIFICATIONS TO THE SITE AND SERVICES</h5>
                    <p>
                      We reserve the right at any time in our sole discretion to
                      modify, discontinue, or remove, temporarily or
                      permanently, the Site and/or Services (or any part
                      thereof) with or without notice. We will not be liable to
                      you or to any third party for any such modification,
                      suspension, removal, or discontinuance. We do not
                      guarantee that any of your Content or any other Content
                      will be available on the Site, our servers and/or
                      directories at any time, or for any period of time.
                    </p>
                    <br />
                    <h5>9. TERMINATION OF ACCESS</h5>
                    <p>
                      We may, in our sole and absolute discretion and without
                      notice or liability to you or any third party, immediately
                      suspend, limit your access to and/or terminate your access
                      to the Site, Services, and/or your Account for any reason
                      or for no reason, including without limitation:
                    </p>
                    <ol>
                      <li>
                        (a) if we believe in our sole discretion that you have
                        violated these Terms, any Access Service Agreement, or
                        any applicable laws or regulations;
                      </li>
                      <li>
                        (b) at the request of law enforcement, government
                        agencies or courts;
                      </li>
                      <li>(c) if you ask us to close your Account;</li>
                      <li>
                        (d) if we discontinue or materially modify the Site or
                        Services (or any part thereof);
                      </li>
                      <li>
                        (e) if unexpected technical or security issues or
                        problems arise;
                      </li>
                      <li>
                        (f) if we believe in our sole discretion that your use
                        or access to the Site, Services, or your Account may
                        create risk (including but not limited to legal risk)
                        for us, our affiliates, contractual partners, or users;
                        and/or
                      </li>
                      <li>
                        (g) following extended periods of inactivity on your
                        Account (six (6) months or longer).
                      </li>
                    </ol>
                    <p>
                      Termination of your access to the Site, Services, and/or
                      your Account may include in our sole discretion, but is
                      not limited to: (x) removal of access to some or all
                      offerings on the Site and Services; (y) the deletion of
                      some or all of your Content, Account information, and/or
                      other content associated with your use of the Site,
                      Services, and/or your Account (or any part thereof) from
                      the Site, our servers and/or directories; and/or (z)
                      banning you from using the Site and Services by any
                      available means, including without limitation by blocking
                      your IP address.
                    </p>
                    <p>
                      Any suspension or termination shall not affect your
                      obligations to us under these Terms. The provisions of
                      these Terms which by their nature should survive the
                      suspension or termination of your access to or use of the
                      Site, Services, and/or your Account shall survive
                      including, but not limited to, the rights and licenses
                      that you have granted hereunder, indemnities, releases,
                      disclaimers, limitations on liability, provisions related
                      to choice of law, dispute resolution, and all of the
                      miscellaneous provisions set forth below.
                    </p>
                    <br />
                    <h5>10. INDEMNITY</h5>
                    <p>
                      You agree to indemnify, defend, and hold Trainery1
                      Software, its affiliates, and its and their respective
                      members, officers, directors, owners, employees, agents,
                      partners, licensors, service providers, successors, and
                      assigns (collectively, the "Indemnified Parties") harmless
                      from and against any third-party claims, liabilities,
                      losses, damages, obligations, costs, and expenses
                      (including but not limited to reasonable attorneys' fees
                      and costs) ("Claims") arising out of or relating to your
                      use of the Site or Services, your Content, your breach of
                      these Terms, and/or your acts or omissions relating to any
                      of the foregoing. We have the right to control the
                      defense, settlement, and/or other resolution of any
                      Claims, at your sole cost and expense. You may not settle
                      or otherwise resolve any Claim without our express written
                      permission.
                    </p>
                    <br />
                    <h5>11. DISCLAIMER OF WARRANTIES</h5>
                    <p>
                      YOU EXPRESSLY UNDERSTAND AND AGREE THAT YOUR USE OF THE
                      SITE AND SERVICES IS AT YOUR SOLE RISK. THE SITE,
                      SERVICES, AND THE SITE CONTENT ARE PROVIDED ON AN "AS IS"
                      AND "AS AVAILABLE" BASIS WITH ALL FAULTS. WITHOUT LIMITING
                      THE FOREGOING AND TO THE FULLEST EXTENT OF THE LAW, THE
                      INDEMNIFIED PARTIES EXPRESSLY DISCLAIM ALL WARRANTIES OF
                      ANY KIND, INCLUDING ANY: (A) WARRANTIES THAT THE SITE,
                      SERVICES, OR SITE CONTENT WILL MEET YOUR REQUIREMENTS OR
                      SATISFACTION; (B) WARRANTIES CONCERNING THE AVAILABILITY,
                      ACCURACY, SECURITY, USEFULNESS, TIMELINESS, OR
                      INFORMATIONAL CONTENT OF THE SITE, SERVICES, OR SITE
                      CONTENT; (C) WARRANTIES OF TITLE, NON-INFRINGEMENT,
                      MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE; (D)
                      WARRANTIES CONCERNING THE CAPACITY, COMPLETENESS,
                      ACCURACY, OR RELIABILITY OF THE INFORMATION OR RESULTS
                      THAT MAY BE OBTAINED FROM THE USE OF THE SITE AND/OR
                      SERVICES; (E) WARRANTIES THAT YOUR USE OF THE SITE WILL BE
                      SECURE OR UNINTERRUPTED; AND (F) WARRANTIES THAT THE SITE,
                      SERVICES, AND/OR SITE CONTENT WILL BE ERROR-FREE OR THAT
                      ERRORS IN THE SITE, SERVICES, AND/OR SITE CONTENT WILL BE
                      CORRECTED. WE ASSUME NO RESPONSIBILITY FOR THE TIMELINESS,
                      DELETION, MIS-DELIVERY OR FAILURE TO PROVIDE ANY CONTENT
                      OR TO STORE ANY PERSONALIZATION SETTINGS OR CONTENT. NO
                      ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED
                      BY YOU FROM US OR THROUGH OR FROM THE SITE OR SERVICES
                      SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THESE
                      TERMS.
                    </p>
                    <br />
                    <h5>12. LIMITATION OF LIABILITY</h5>
                    <p>
                      WE MAY USE THIRD PARTIES TO PROVIDE CERTAIN SERVICES
                      ACCESSIBLE THROUGH THE SITE AND SERVICES. WE WILL NOT BE
                      LIABLE TO YOU FOR THEIR ACTS OR OMISSIONS.
                    </p>
                    <p>
                      TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW,
                      UNDER NO CIRCUMSTANCES, INCLUDING, WITHOUT LIMITATION, THE
                      NEGLIGENCE OF ANY PARTY, WILL THE INDEMNIFIED PARTIES BE
                      LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL,
                      CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING, WITHOUT
                      LIMITATION, DAMAGES FOR LOSS OF PROFITS, LOSS OF LOSS OF
                      USE, DATA LOSS, OR OTHER INTANGIBLE LOSSES (EVEN IF THE
                      INDEMNIFIED PARTIES HAVE BEEN ADVISED OF THE POSSIBILITY
                      OF SUCH DAMAGES), RESULTING FROM, ARISING OUT OF, RELATING
                      TO, OR IN ANY WAY CONNECTED WITH YOUR USE OF, OR YOUR
                      INABILITY TO USE, THE SITE OR SERVICES, UNDER ANY THEORY
                      OF LIABILITY. YOUR SOLE REMEDY, AND OUR AGGREGATE
                      LIABILITY IN CONNECTION WITH THESE TERMS OR YOUR USE OF
                      THE SITE AND SERVICES, SHALL IN ALL EVENTS BE LIMITED TO
                      THE GREATER OF FIFTY DOLLARS ($50.00) OR THE TOTAL AMOUNTS
                      PAID BY YOU TO US FOR THE SERVICES GIVING RISE TO SUCH
                      LIABILITY DURING THE SIX (6) MONTHS IMMEDIATELY PRECEDING
                      THE CLAIM.
                    </p>
                    <p>
                      SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR
                      EXCLUSION OF LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL
                      DAMAGES, SO SOME OF THE ABOVE PROVISIONS MAY NOT APPLY TO
                      YOU. IN SUCH JURISDICTIONS, OUR LIABILITY IS LIMITED TO
                      THE FULLEST EXTENT OF THE LAW.
                    </p>
                    <p>
                      YOU SPECIFICALLY ACKNOWLEDGE AND AGREE THAT WE WILL NOT BE
                      LIABLE FOR THE ILLEGAL, OFFENSIVE OR DEFAMATORY CONDUCT OF
                      OTHERS, INCLUDING BUT NOT LIMITED TO ANY SUCH CONDUCT BY
                      YOU, AND THAT YOU BEAR ALL RISK AND LIABILITY ASSOCIATED
                      WITH YOUR CONDUCT AND CONTENT.
                    </p>
                    <br />
                    <h5>13. RELEASE</h5>
                    <p>
                      YOU HEREBY RELEASE THE INDEMNIFIED PARTIES FROM ANY AND
                      ALL CLAIMS, DEMANDS AND DAMAGES OF EVERY KIND AND NATURE,
                      KNOWN AND UNKNOWN, ARISING OUT OF, RELATING TO OR IN ANY
                      WAY CONNECTED WITH YOUR USE OF THE SITE AND/OR SERVICES.
                      IF YOU ARE A RESIDENT OF CALIFORNIA, YOU WAIVE CALIFORNIA
                      CIVIL CODE § 1542 WHICH STATES “A GENERAL RELEASE DOES NOT
                      EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR
                      SUSPECT TO EXIST IN HIS FAVOR AT THE TIME OF EXECUTING THE
                      RELEASE, WHICH IF KNOWN BY HIM MUST HAVE MATERIALLY
                      AFFECTED HIS SETTLEMENT WITH THE DEBTOR.”
                    </p>
                    <br />
                    <h5>14. DATA PRIVACY</h5>
                    <p>
                      We, our service providers, and other partners collect
                      information from and/or about you when you use the Site
                      and Services and process that information in accordance
                      with our Privacy Policy.
                    </p>
                    <br />
                    <h5>15. MISCELLANEOUS</h5>
                    <p>
                      a. Exclusive Venue for Litigation; JURY TRIAL WAIVER. You
                      and we agree that any litigation between us shall be filed
                      exclusively in state or federal courts located in Raleigh
                      Wake County, North Carolina. You expressly consent to
                      exclusive jurisdiction in Wake County, North Carolina for
                      any litigation between us. These Terms shall be construed
                      in accordance with the laws of the State of North Carolina
                      without regard to its conflict of laws rules that would
                      result in the application of the laws of a jurisdiction
                      other than the State of North Carolina. YOU AND TRAINERY
                      ALSO EXPRESSLY AGREE THAT PARTIES EXPRESSLY WAIVE THE
                      RIGHT TO TRIAL BY JURY.
                    </p>
                    <br />
                    <p>
                      b. Waiver and Severability of Terms. The failure of
                      Trainery1 Software to exercise or enforce any right or
                      provision of these Terms shall not constitute a waiver of
                      such right or provision. If any provision of these Terms
                      is found by a court of competent jurisdiction to be
                      invalid or unenforceable, the parties nevertheless agree
                      that the court should endeavor to give effect to the
                      parties’ intentions as reflected in the invalid or
                      unenforceable provision, and all other provisions of these
                      Terms shall remain in full force and effect.
                    </p>
                    <br />
                    <p>
                      c. No Contest. Our electronically or otherwise properly
                      stored copy of these Terms will be deemed to be the true,
                      complete, valid, authentic, and enforceable copy, and you
                      agree that you will not contest the admissibility or
                      enforceability of our copy of these Terms in connection
                      with any action or proceeding arising out of or relating
                      to these Terms.
                    </p>
                    <br />
                    <p>
                      d. Assignment. We may assign our rights and duties under
                      these Terms at any time to any third party without notice.
                      You may not assign these Terms without our prior written
                      consent.
                    </p>
                    <br />
                    <p>
                      e. No Third Party Beneficiaries. You agree that, except as
                      otherwise expressly provided in the Terms, there shall be
                      no third party beneficiaries to these Terms.
                    </p>
                    <br />
                    <p>
                      f. Statute of Limitations. You agree that regardless of
                      any statute or law to the contrary, any claim or cause of
                      action arising out of or related to the use of the Site,
                      Services, or these Terms must be filed within one (1) year
                      after such claim or cause of action arose or be forever
                      barred.
                    </p>
                    <br />
                    <p>
                      g. Entire Agreement. These Terms (together with the
                      Privacy Policy and any Access Service Agreement entered
                      into between you and Trainery) constitute the entire
                      agreement between you and us with respect to your access
                      to and use of the Site and Services, and any and all other
                      written or oral agreements or understandings previously
                      existing between you and us with respect to the subject
                      matter hereof are hereby superseded and canceled.
                    </p>
                    <br />
                    <p>
                      h. Force Majeure. Failure by either party to perform any
                      obligation hereunder shall be excused if and for so long
                      as such breach or failure to perform is caused by a force
                      majeure event, and prompt notice thereof has been given to
                      the other party. If either party fails to perform any duty
                      or obligation hereunder as a result of a force majeure
                      event, such party shall be required to fulfill its
                      obligations hereunder within a reasonable time frame after
                      the force majeure event ceases to exist.
                    </p>
                    <br />
                    <p>
                      i. Questions. Please contact us with any questions
                      regarding the Site, Services, or these Terms at
                      support@trainery.one. Any feedback or questions that you
                      provide shall be deemed to be non-confidential, and we
                      shall be free to use such information in accordance with
                      our Privacy Policy.
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      height: "2rem",
                      paddingTop: "1rem",
                    }}
                  >
                    <Button
                      key="back"
                      style={{ marginRight: "1rem", fontSize: "1.5rem" }}
                      onClick={() => {
                        history("/home");
                      }}
                    >
                      <BackwardOutlined /> Back
                    </Button>

                    <Button
                      type="primary"
                      href={PDF}
                      style={{ fontSize: "1.5rem" }}
                      rel="noopener noreferrer"
                      download="T1 Terms and Conditions.pdf"
                    >
                      <DownloadOutlined />
                      PDF
                    </Button>
                  </div>
                </>
              </Card>
            </div>
          </div>
        </div>
        <footer>
          <Footer />
        </footer>
      </div>
    </div>
  );
};

export default TermsService;
